import Config from './config'

// global configuration variable loaded via a <style> tag in index.html
// @ts-ignore
const CONFIG: Config = TS_CONFIG
export default CONFIG
